module.exports = __webpack_public_path__ + "media/images/general/brands/diners-fc7eeba462715d8a6caa5368b0ab5dd3.png";